import styled from 'styled-components';

export const MarkdownContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(4)}px;
  border: 1px solid ${({ theme }) => theme.colors.on[100]};
  border-radius: ${({ theme }) => theme.spacing(2)}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
`;

export const ReferencesList = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
  padding-top: ${({ theme }) => theme.spacing(3)}px;
  border-top: 1px solid ${({ theme }) => theme.colors.on[100]};
  font-size: 0.875rem;
`;
